export default "__VITE_ASSET__26f975a3__"